import React, { memo } from "react";
import ATOLLogoSvg from "../../../assets/icons/atol-protected-logo.svg";
const _ATOLLogo = (props) => {
    return React.createElement(ATOLLogoSvg, { alt: "", "aria-hidden": "true", width: 24, height: 24, ...props });
};
export const ATOLLogo = memo(_ATOLLogo);
